import FormatText from './FormatText';
import LimitInputNIP from './LimitInputNIP';
import LimitInputPESEL from './LimitInputPESEL';
import LimitInputPhoneOrService from './LimitInputPhoneOrService';
import MaximizeWidget from './MaximizeWidget';
import SetQuestionnaireName from './SetQuestionnaireName';
import ShowOptions from './ShowOptions';
import ShowAddressForm from './ShowAddressForm';

const ProcessorsArray = [
    FormatText,
    LimitInputNIP,
    LimitInputPESEL,
    LimitInputPhoneOrService,
    SetQuestionnaireName,
    ShowOptions,
    ShowAddressForm,
    MaximizeWidget
];

export default class Processors {
    static getProcessor(name) {
        return ProcessorsArray.find((p) => p.name === name);
    }
}
